import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { Drawer, Button, message } from 'antd';

import CreateFont from './CreateFont';

import { get, post, put } from '../utils/httpRequests';
import { APIs } from '../utils/apis';

const columns = [
  {
    title: 'Name',
    width: 10
  },
  {
    title: 'Type',
    width: 10
  },
  {
    title: 'Format',
    width: 10
  },
  {
    title: 'Family',
    width: 20
  },
  {
    title: 'URL',
    width: 40
  },
  {
    title: 'Action',
    width: 10
  }
];

const Fonts = () => {
  const [state, setState] = useState({
    isFetching: true,
    fonts: [],
    showDrawer: false,
    currentFont: {}
  });

  const fetchFonts = async () => {
    let url = APIs.FONT;
    try {
      const response = await get({ url });
      if (!response) {
        message.error('Fetch fonts failed');
      }
      if (response?.data?.meta?.status === 200 && response?.data?.result) {
        state.fonts = response.data.result;
        setState({ isFetching: false, fonts: response.data.result });
      }
      setState({ ...state, isFetching: false });
    } catch (error) {
      message.error(error + ': Fetch fonts failed');
      setState({ ...state, isFetching: false });
    }
  };

  useEffect(() => {
    fetchFonts();
  }, []);

  const showDrawer = (isEdit, font) => {
    setState({
      ...state,
      showDrawer: true,
      currentFont: isEdit
        ? font
        : {
            name: '',
            URL: '',
            type: '',
            format: '',
            family: ''
          }
    });
  };

  const closeDrawer = () => {
    setState({ ...state, showDrawer: false, currentFont: {} });
  };

  const onSubmit = () => {
    const url = APIs.FONT;
    const request = state.currentFont.id
      ? put({ url, data: state.currentFont })
      : post({ url, data: state.currentFont });

    request
      .then(res => {
        if (res?.data?.meta?.status === 200) {
          message.success(
            'Font ' + state.currentFont.id
              ? 'updated '
              : 'created ' + 'successfully'
          );
          fetchFonts();
          closeDrawer();
        }
      })
      .catch(err => {
        message.error(err + ': Service error');
      });
  };

  const onChange = e => {
    const { name, value } = e.target;
    setState({
      ...state,
      currentFont: { ...state.currentFont, [name]: value }
    });
  };

  const onSelectChange = value => {
    setState({
      ...state,
      currentFont: { ...state.currentFont, format: value }
    });
  };

  return (
    <div>
      <div className="d-flex justify-content-between">
        <h2 className="">Uploaded Fonts</h2>
        <Button
          className="margin-bottom-10 margin-lr-8"
          type="primary"
          onClick={() => showDrawer(false, {})}
        >
          + Add New Font
        </Button>
      </div>
      <table className={`ant-table ant-table-small width-100pt`}>
        <thead className="ant-table-thead">
          <tr>
            {columns.map((item, i) => (
              <th className="padding-8" key={i} width={`${item.width}%`}>
                {item.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="ant-table-tbody">
          {!state.isFetching
            ? state.fonts.map((item, i) => (
                <tr key={i}>
                  <td className="padding-8">{item.name}</td>
                  <td className="padding-8">{item.type}</td>
                  <td className="padding-8">{item.format}</td>
                  <td className="padding-8">{item.family}</td>
                  <td className="padding-8">{item.URL}</td>
                  <td className="padding-8">
                    <Button
                      type="primary"
                      onClick={() => showDrawer(true, item)}
                    >
                      Open
                    </Button>
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </table>
      {state.showDrawer && (
        <Drawer
          title={
            state.currentFont.id
              ? `Editing Font: ${state.currentFont.name}`
              : 'Create New Font'
          }
          placement="right"
          onClose={closeDrawer}
          visible={state.showDrawer}
          width={'50%'}
        >
          <CreateFont
            font={state.currentFont}
            onClick={onSubmit}
            onChange={onChange}
            onSelectChange={onSelectChange}
          />
        </Drawer>
      )}
    </div>
  );
};

export default withRouter(Fonts);
